// services/principal-investigator-report.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { PrincipalInvestigatorReportList } from '../principal-investigator/models/principal-investigator-report-list';
import { SearchPrincipalInvestigator } from '../principal-investigator/models/principal-investigator-report';
import { ApiService } from '@shared/services/api/api.service';
import { ConfigurationService } from '@core/services/configuration/configuration.service';
import { NgxNotifyService } from '@shared/services/ngx-notify/ngx-notify.service';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';

@Injectable({ providedIn: 'root' })
export class PrincipalInvestigatorReportService extends ApiService {
 private readonly STORAGE_KEY = 'piReport.filters.v1';
 constructor(
 private httpClient: HttpClient,
 config: ConfigurationService,
 notify: NgxNotifyService,
 router: Router,
 fb: FormBuilder
 ) {
 super(httpClient, config, notify, router, fb);
 this.form = fb.group({
   firstName: [''],
   lastName: [''],
   institutionId: [null as number | null],
   userStatus: ['Active'],
   protocolStatuses: [['Active', 'Exempt']], // default multi-select selections
  });
 }

 save(): void {
 const { firstName, lastName, institutionId, userStatus, protocolStatuses } = this.form.getRawValue();
 const state = {
 firstName: (firstName || '').trim(),
 lastName: (lastName || '').trim(),
 institutionId: institutionId ?? null,
 userStatus: userStatus || 'Active',
 protocolStatuses: (protocolStatuses || []) as string[],
 pageIndex: this.pageIndex,
 pageSize: this.pageSize,
 sort: this.sort,
 order: this.order
 };
 localStorage.setItem(this.STORAGE_KEY, JSON.stringify(state));
 }

 clear(): void {
 localStorage.removeItem(this.STORAGE_KEY);
   this.form.reset({
     firstName: '',
     lastName: '',
     institutionId: null,
     userStatus: 'Active',
     protocolStatuses: ['Active', 'Exempt'],
 
 }, { emitEvent: false });
 this.pageIndex = 1; this.pageSize = 10; this.sort = 'LastName'; this.order = 'asc';
 }

 handleSortChange(sort: Sort, fetch: () => void): void {
 switch (sort.active) {
 case 'firstName': this.sort = 'FirstName'; break;
 case 'lastName': this.sort = 'LastName'; break;
 case 'institution': this.sort = 'Institution'; break;
 case 'email': this.sort = 'Email'; break;
 case 'phone': this.sort = 'Phone'; break;
 default: this.sort = 'LastName';
 }
 this.order = (sort.direction || 'asc') as 'asc' | 'desc';
 this.pageIndex = 1;
 this.save();
 fetch();
 }

 handlePage(evt: PageEvent, fetch: () => void): void {
 this.pageIndex = (evt.pageIndex || 0) + 1;
 this.pageSize  = evt.pageSize;
 this.save();
 fetch();
 }

 form!: FormGroup;
 // table state
 pageIndex = 1;  // 1-based
 pageSize  = 10;
 sort: 'FirstName' | 'LastName' | 'Institution' | 'Email' | 'Phone' = 'LastName';
 order: 'asc' | 'desc' = 'asc';


 // service
 getReport(dto: SearchPrincipalInvestigator): Observable<PrincipalInvestigatorReportList> {
 const parts: string[] = [];
 if (dto.firstName) parts.push(`firstName=${encodeURIComponent(dto.firstName)}`);
 if (dto.lastName)  parts.push(`lastName=${encodeURIComponent(dto.lastName)}`);
 if (dto.institutionId && dto.institutionId > 0) parts.push(`institutionId=${dto.institutionId}`);
 if (dto.userStatus && dto.userStatus !== 'All') parts.push(`userStatus=${encodeURIComponent(dto.userStatus)}`);
 if (dto.protocolStatuses && dto.protocolStatuses.length) parts.push(`protocolStatuses=${encodeURIComponent(dto.protocolStatuses.join(','))}`);

 const filter = parts.join('&');
 return this.searchReport<PrincipalInvestigatorReportList>(
 'report/PrincipalInvestigator',
 filter,
 dto.sort || 'LastName',
 dto.order || 'asc',
 (dto.pageIndex || 1) - 1,
 dto.pageSize || 10
 );
 }

 exportExcel(dto: SearchPrincipalInvestigator): Observable<Blob> {
 const filterQueryParts: string[] = [];
 if (dto.firstName) filterQueryParts.push(`firstName=${encodeURIComponent(dto.firstName)}`);
 if (dto.lastName) filterQueryParts.push(`lastName=${encodeURIComponent(dto.lastName)}`);
 if (dto.institutionId && dto.institutionId >0) filterQueryParts.push(`institutionId=${dto.institutionId}`);
 if (dto.userStatus && dto.userStatus !== 'All') filterQueryParts.push(`userStatus=${encodeURIComponent(dto.userStatus)}`);
 if (dto.protocolStatuses && dto.protocolStatuses.length) filterQueryParts.push(`protocolStatuses=${encodeURIComponent(dto.protocolStatuses.join(','))}`);
   const filterQuery = filterQueryParts.join('&');

 return this.downloadExcelFile(`report/PrincipalInvestigator?${filterQuery}&forExcel=true`);
  }


}
